import { Typography } from 'core/components/Core'

type SidebarItemProps = {
  title: string
  subtitle?: string
  children: React.ReactNode
}

export const SidebarItem = ({ title, subtitle, children }: SidebarItemProps) => {
  return (
    <div className="d-flex w-100 mb-3" style={{ border: '1px solid #ECECEC' }}>
      <div
        className="d-flex flex-column justify-between p-2 flex-1"
        style={{ backgroundColor: '#F7F7F7' }}
      >
        <Typography variant="subtitle2">{title}</Typography>

        <Typography variant="caption" className="mt-2" style={{ fontWeight: 400 }}>
          {subtitle}
        </Typography>
      </div>

      <div className="d-flex flex-column" style={{ backgroundColor: '#fff', flex: 4 }}>
        {children}
      </div>
    </div>
  )
}
